import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import {
  Icon,
  IconComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
} from '@web/shared/ui';
import { Button } from 'primeng/button';
import { AdminBoxCosmetic } from '../../models/admin-box-cosmetic';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-admin-box-cosmetics-grid',
  imports: [
    Button,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    IconComponent,
    Tooltip,
  ],
  templateUrl: './admin-box-cosmetics-grid.component.html',
  styleUrl: './admin-box-cosmetics-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxCosmeticsGridComponent {
  public readonly items = input.required<AdminBoxCosmetic[]>();
  public readonly isReadonly = input(false);
  public readonly removeClickEvent = output<Guid>();

  protected readonly Icon = Icon;
  protected readonly isNotNil = isNotNil;

  public handleRemoveClick(item: AdminBoxCosmetic): void {
    this.removeClickEvent.emit(item.id);
  }
}
